import dataPeriEdo from "../../../../src/data/periprocedureel-beleid-edoxaban.json";
import BasicCollapse from "../../../../src/components/chart/interaction/basic-collapse/Chart.js";
import * as React from 'react';
export default {
  dataPeriEdo,
  BasicCollapse,
  React
};